module.exports = __webpack_public_path__ + "060bfa65eed3a101ec4b0ac5f68cfee3.pdf";